(function () {
  function injectWordmark() {
    var tpl = document.getElementById('gg-chrome-wordmark-tpl');
    var header = document.querySelector('[data-section-type="header"]');
    if (!tpl || !header) return;

    var logoLink = header.querySelector('.site-logo a');
    if (!logoLink) return;

    header.classList.add('gg-chrome-header');

    // Se dal theme editor è stato caricato un logo immagine, quello vince:
    // niente wordmark testuale al suo posto.
    if (logoLink.querySelector('.site-logo--image')) return;
    if (logoLink.querySelector('.gg-chrome-wordmark')) return;

    logoLink.innerHTML = tpl.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectWordmark);
  } else {
    injectWordmark();
  }
})();
